export default __webpack_public_path__ + "static/media/Fala mechaniczna.cd23734e.png";